import type { ReactNode } from 'react';
import { ApiError } from '../api/client';

export function LoadingState({ label = 'Загрузка…' }: { label?: string }) {
  return (
    <div className="state" role="status" aria-live="polite">
      <span className="visually-hidden">{label}</span>
      <div className="skeleton" aria-hidden="true">
        <span />
        <span />
        <span />
      </div>
    </div>
  );
}

export function ErrorState({
  error,
  title = 'Не удалось загрузить данные',
  onRetry,
}: {
  error: unknown;
  title?: string;
  onRetry?: () => void;
}) {
  const message = error instanceof Error ? error.message : 'Неизвестная ошибка';
  const requestId = error instanceof ApiError ? error.requestId : undefined;
  return (
    <div className="state state-error" role="alert">
      <p className="state-title">{title}</p>
      <p className="state-text">{message}</p>
      {requestId ? <p className="state-meta">Код запроса: {requestId}</p> : null}
      {onRetry ? (
        <button type="button" className="btn-secondary" onClick={onRetry}>
          Повторить
        </button>
      ) : null}
    </div>
  );
}

export function EmptyState({
  title,
  children,
  action,
}: {
  title: string;
  children?: ReactNode;
  action?: ReactNode;
}) {
  return (
    <div className="empty">
      <strong>{title}</strong>
      {children ? <span>{children}</span> : null}
      {action}
    </div>
  );
}
